<cf-frontend-sdk-cplace-control-skeleton
  [componentId]="componentId"
  [label]="label"
  [labelPosition]="labelPosition"
  [validationMessage]="validationMessage"
  [validationSeverity]="validationSeverity"
  [alert]="alert"
  [required]="required"
  [editMode]="($editMode | async)!"
  [submitting]="submitting"
  [submitSuccess]="($submitSuccess | async)!"
  [submitDisabled]="($submitDisabled | async)!"
  [readonly]="readonly"
  [disabled]="disabled"
  [grouped]="true"
  (cancelButtonClick)="onCancel()"
>
  <ng-container *ngIf="!isTextArea">
    <div class="cf-frontend-sdk-cplace-single-localized-text-content-column">
      <div
        class="cf-frontend-sdk-cplace-single-localized-text-control-container"
        *ngFor="let localizationDisplayData of $localizationsDisplayData | async; let i = index; trackBy: localizationsDisplayDataTrackBy"
        [class.cf-frontend-sdk-empty-value]="localizationDisplayData.showEmptyValue"
      >
        <cf-frontend-sdk-language-icon [languageId]="localizationDisplayData.languageId"></cf-frontend-sdk-language-icon>
        <input
          #cplaceSingleLocalizedTextTextElement
          [(ngModel)]="localizedText.supportedLocalizations[i].value"
          (ngModelChange)="onNgModelChange()"
          [disabled]="disabled"
          [readonly]="readonly"
          [required]="required"
          [placeholder]="localizationDisplayData.placeholder"
          [attr.aria-placeholder]="localizationDisplayData.placeholder"
          [attr.aria-label]="localizationDisplayData.label"
          [attr.aria-required]="required"
          [attr.aria-disabled]="disabled"
          [attr.aria-readonly]="readonly"
          [attr.aria-invalid]="validationSeverity !== 'info'"
          [name]="localizationDisplayData.placeholder"
          autocomplete="off"
          type="text"
          pInputText
        />
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isTextArea">
    <div class="cf-frontend-sdk-cplace-single-localized-text-content-column">
      <div
        class="cf-frontend-sdk-cplace-single-localized-text-control-container"
        *ngFor="let localizationDisplayData of $localizationsDisplayData | async; let i = index; trackBy: localizationsDisplayDataTrackBy"
        [class.cf-frontend-sdk-empty-value]="localizationDisplayData.showEmptyValue"
      >
        <cf-frontend-sdk-language-icon [languageId]="localizationDisplayData.languageId"></cf-frontend-sdk-language-icon>
        <textarea
          #cplaceSingleLocalizedTextTextElement
          [(ngModel)]="localizedText.supportedLocalizations[i].value"
          (ngModelChange)="onNgModelChange()"
          [disabled]="disabled"
          [readonly]="readonly"
          [required]="required"
          [name]="localizationDisplayData.placeholder"
          [placeholder]="localizationDisplayData.placeholder"
          [attr.aria-placeholder]="localizationDisplayData.placeholder"
          [attr.aria-label]="localizationDisplayData.label"
          [attr.aria-required]="required"
          [attr.aria-disabled]="disabled"
          [attr.aria-readonly]="readonly"
          [attr.aria-invalid]="validationSeverity !== 'info'"
          pInputTextarea
          [autoResize]="true"
        ></textarea>
      </div>
    </div>
  </ng-container>
</cf-frontend-sdk-cplace-control-skeleton>
